const BASE_SHARE_URL = "https://www.bilibili.com/blackboard/redpack/activity-PBnicOEeUP.html";
const ACTIVITY_ID = "cheers-card";

export { BASE_SHARE_URL, ACTIVITY_ID };

export enum ActivityStatus {
  NOT_START = 0,
  END = 2,
  COLLECTING = 3,
  AWARD = 4,
  RESULT = 5
}

export const THEME_PIC_MAP = {
  FOOD: "https://activity.hdslb.com/blackboard/static/20210426/a80f01ce8c1293f4d6ff28d53201c2b3/gwTM1SNmyL.png",
  FASION: "https://activity.hdslb.com/blackboard/static/20210426/a80f01ce8c1293f4d6ff28d53201c2b3/0KG81qNUXy.png",
  GAME: "https://activity.hdslb.com/blackboard/static/20210426/a80f01ce8c1293f4d6ff28d53201c2b3/n4qCE2Zg3P.png",
  TRAVEL: "https://activity.hdslb.com/blackboard/static/20210426/a80f01ce8c1293f4d6ff28d53201c2b3/jDOSE7rYua.png",
  KNOWLEDGE: "https://activity.hdslb.com/blackboard/static/20210426/a80f01ce8c1293f4d6ff28d53201c2b3/DoVAMRc9np.png"
};

// 用来判断是否首次进入该活动的k
export const K = "699";
